
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_1lhbz_17",
  "full-width": "awsui_full-width_8cbea_1lhbz_44",
  "refresh": "awsui_refresh_8cbea_1lhbz_47",
  "disabled": "awsui_disabled_8cbea_1lhbz_53",
  "selected": "awsui_selected_8cbea_1lhbz_116",
  "icon": "awsui_icon_8cbea_1lhbz_128",
  "with-text": "awsui_with-text_8cbea_1lhbz_132",
  "with-no-text": "awsui_with-no-text_8cbea_1lhbz_141",
  "root": "awsui_root_8cbea_1lhbz_146",
  "segment-part": "awsui_segment-part_8cbea_1lhbz_178",
  "grouped": "awsui_grouped_8cbea_1lhbz_203",
  "grouped-only": "awsui_grouped-only_8cbea_1lhbz_203",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_1lhbz_207",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_1lhbz_219",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_1lhbz_223",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_1lhbz_229",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_1lhbz_233",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_1lhbz_237",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_1lhbz_243",
  "grouped-with-action": "awsui_grouped-with-action_8cbea_1lhbz_247",
  "grouped-with-error": "awsui_grouped-with-error_8cbea_1lhbz_251",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_8cbea_1lhbz_279",
  "grouped-vertical-only": "awsui_grouped-vertical-only_8cbea_1lhbz_279",
  "grouped-with-warning": "awsui_grouped-with-warning_8cbea_1lhbz_285",
  "grouped-row-first": "awsui_grouped-row-first_8cbea_1lhbz_319",
  "select": "awsui_select_8cbea_1lhbz_116",
  "segment-count-2": "awsui_segment-count-2_8cbea_1lhbz_349",
  "segment-count-3": "awsui_segment-count-3_8cbea_1lhbz_356",
  "segment-count-4": "awsui_segment-count-4_8cbea_1lhbz_363",
  "segment-count-5": "awsui_segment-count-5_8cbea_1lhbz_370",
  "segment-count-6": "awsui_segment-count-6_8cbea_1lhbz_377",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_1lhbz_384"
};
  